import { Card } from "@redotech/arbiter/card";
import { Flex } from "@redotech/arbiter/flex";
import { RedoIncrementDecrement } from "@redotech/arbiter/increment-decrement/redo-increment-decrement";
import { RedoToggle } from "@redotech/arbiter/toggle/redo-toggle";
import { SuppliesPaymentTerms } from "@redotech/redo-fulfillment-common/supplies";
import { FormSelectDropdown } from "@redotech/redo-web/select-dropdown";
import { input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const suppliesEnabledInput = input<boolean>();
export const suppliesEnabledDefault = false;

// Undefined = immediate (charge the chosen method at checkout).
export const paymentTermsInput = input<SuppliesPaymentTerms | undefined>();
export const paymentTermsDefault = undefined;

// 0 = no override; the sweep falls back to the platform default.
export const pullForwardWindowDaysInput = input<number | undefined>();
export const pullForwardWindowDaysDefault = undefined;

/** Mirrors DEFAULT_PULL_FORWARD_WINDOW_DAYS in the due-for-reorder activity. */
const DEFAULT_PULL_FORWARD_WINDOW_DAYS = 7;

const PAYMENT_TERMS_LABEL: Record<SuppliesPaymentTerms, string> = {
  [SuppliesPaymentTerms.Net15]: "Net 15",
  [SuppliesPaymentTerms.Net30]: "Net 30",
};

export const SuppliesSettingsCard = memo(function SuppliesSettingsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  return (
    <Card title="Supplies settings" w="full">
      <Flex dir="column" gap="md">
        <RedoToggle
          label="Supplies enabled"
          setValue={input.inputs.suppliesEnabled.setValue}
          size="sm"
          value={input.inputs.suppliesEnabled.value}
        />
        <FormSelectDropdown
          input={input.inputs.paymentTerms}
          label="Payment terms"
          options={[
            undefined,
            SuppliesPaymentTerms.Net15,
            SuppliesPaymentTerms.Net30,
          ]}
        >
          {(option) => (option ? PAYMENT_TERMS_LABEL[option] : "Immediate")}
        </FormSelectDropdown>
        <RedoIncrementDecrement
          description={`How far ahead an inventory config can be pulled into an order already shipping to the same destination. 0 uses the default of ${DEFAULT_PULL_FORWARD_WINDOW_DAYS} days.`}
          label="Pull forward window"
          min={0}
          setValue={(value) =>
            input.inputs.pullForwardWindowDays.setValue(
              value > 0 ? Math.round(value) : undefined,
            )
          }
          suffix="days"
          value={input.inputs.pullForwardWindowDays.value ?? 0}
        />
      </Flex>
    </Card>
  );
});
